import { useBranchLocation, valueProduct } from "application";
import { AddToHead } from "components";
import { catalogApi, cookie, weddingGiftListApi } from "implementations";
import { useRouter } from "next/router";
import { CoupleNamesDto, IHttpResponse, Price } from "typing";
import { cookieAccessToken } from "../../utils/constants";
import { PaymentMethods } from "./components";
import { useViewPaymentMethods } from "./components/ViewPaymentMethods/ViewPaymentMethods.service";
import { PaymentMethodsMobileContainer } from "./Product.styles";
import { ProductPageProps } from "./Product.types";
import { ProductPageUI } from "./Product.ui";

const Product = ({
  dataProduct,
  blackFridayTheme,
  hasChangesInClientBranchFromRegionIdParam,
  siteUrl,
  cartId,
  branchId,
  productId,
  schema,
}: ProductPageProps) => {
  const router = useRouter();
  const ID_PRODUCT = router?.query?.idProduct;
  const BRANCH_ID_ROUTER = Number(router?.query?.region_id?.at(0));
  const accessToken = cookie.getCookie({
    name: cookieAccessToken,
  }) as string;

  const { getBranchLocationClient } = useBranchLocation();

  const BRANCH_ID = Number.isNaN(BRANCH_ID_ROUTER)
    ? Number(getBranchLocationClient())
    : BRANCH_ID_ROUTER;

  const sellerId = dataProduct?.prices?.[0]?.sellerId;

  const { data } = catalogApi.getProduct(
    Number(ID_PRODUCT),
    BRANCH_ID,
    !!(ID_PRODUCT && BRANCH_ID),
    dataProduct
  );

  const { data: productPrices } = catalogApi.getProductPrices(
    Number(ID_PRODUCT),
    BRANCH_ID,
    dataProduct?.packingLevel || 0,
    sellerId as number,
    !!(ID_PRODUCT && BRANCH_ID && dataProduct && !Number.isNaN(sellerId))
  );

  const { data: activeWeddingList } = weddingGiftListApi.getWeddingList(
    accessToken,
    undefined,
    Boolean(accessToken)
  ) as IHttpResponse<CoupleNamesDto, unknown>;

  const regexToRemoveTheFirstSlash = /^\/(.*)/;

  const product = {
    id: dataProduct?.id,
    brand: dataProduct?.brand,
    productName: dataProduct?.description,
    productTitle: `${dataProduct?.description} | Ferreira Costa`,
    description: `Aqui na Ferreira Costa você encontra ${dataProduct?.description} e muito mais em promoção. Acesse já e confira.`,
    value: productPrices?.[0]?.unitaryValue?.toString(),
    url: `${siteUrl}${router.asPath.replace(regexToRemoveTheFirstSlash, "$1")}`,
    image: dataProduct?.mediaLinks?.at(0)?.imageUrl,
    // Em alinhamento com Pedro(Peixoto) a disponibilidade de um produto deve sempre estar como "instock", pois o produto pode ter em outra filial
    availability: "instock",
  };

  const priceProduct = valueProduct(productPrices?.[0] as Price);

  const {
    isViewMoreComponentOpen,
    setIsViewMorePaymentMethodsOpen,
    paymentMethodsData,
  } = useViewPaymentMethods({
    discountPercentage: String(productPrices?.[0]?.discountPercentage),
    maxNumberInstallments: Number(productPrices?.[0]?.maxNumberInstallments),
    salePrice: productPrices?.[0].salePrice || priceProduct,
    spotPrice: productPrices?.[0].spotPrice,
  });

  return (
    <>
      <AddToHead>
        <meta property="product:brand" content={product?.brand} />
        <meta property="product:price:amount" content={product?.value} />
        <meta property="product:retailer_item_id" content={product?.id} />
        <meta property="product:availability" content={product?.availability} />
        {/* Em alinhamento com Pedro(Peixoto) a condition deve sempre ser "new" */}
        <meta property="product:condition" content="new" />
        <meta property="product:price:currency" content="BRL" />
        {schema && (
          <script type="application/ld+json" id="structured_data">
            {JSON.stringify(schema)}
          </script>
        )}
      </AddToHead>
      {/* <Head
        product={product}
        title={product.productName}
        subtitle="Ferreira Costa"
      /> */}

      {isViewMoreComponentOpen ? (
        <PaymentMethodsMobileContainer>
          <PaymentMethods
            data={paymentMethodsData}
            isMobile
            onClickBackButton={() => setIsViewMorePaymentMethodsOpen(false)}
          />
        </PaymentMethodsMobileContainer>
      ) : (
        <ProductPageUI
          blackFridayTheme={blackFridayTheme}
          hasChangesInClientBranchFromRegionIdParam={
            hasChangesInClientBranchFromRegionIdParam
          }
          siteUrl={siteUrl}
          cartId={cartId}
          dataProduct={data}
          isBlackTheme={blackFridayTheme?.isBlackTheme}
          activeWeddingList={activeWeddingList}
          productPrices={productPrices}
          productId={productId}
          branchId={branchId}
        />
      )}
    </>
  );
};

export default Product;
